import i18nFactory from '@yandex-int/i18n';
import { RadioButton } from 'lego-on-react';
import * as React from 'react';
import { ChangeEvent } from 'react';

import { Bem } from '../../service/Bem/Bem';
import { mapAutobudgetPriorityToString } from '../../service/PhrasesHelpers/PhrasesHelpers';
import { GdShowConditionAutobudgetPriority } from '../../typings/graphql-grid';
import { ButtonDecorator } from '../ButtonDecorator/ButtonDecorator';

import './FeedFilterPriorityForm.css';
import * as keyset from './FeedFilterPriorityForm.i18n';

export interface FeedFilterPriorityFormProps {
    isLoading: boolean;
    note?: string;
    autobudgetPriority: GdShowConditionAutobudgetPriority;
    onAutobudgetPriorityChange: (autobudgetPriority: GdShowConditionAutobudgetPriority) => void;
    onCancel: () => void;
    onSave: () => void;
}

const BLOCK = 'feed-filter-priority-form';

const i18n = i18nFactory(keyset);

export class FeedFilterPriorityForm extends React.PureComponent<FeedFilterPriorityFormProps> {
    private autobudgetPriorities = [
        {
            type: GdShowConditionAutobudgetPriority.LOW,
            text: mapAutobudgetPriorityToString(GdShowConditionAutobudgetPriority.LOW)
        },
        {
            type: GdShowConditionAutobudgetPriority.MEDIUM,
            text: mapAutobudgetPriorityToString(GdShowConditionAutobudgetPriority.MEDIUM)
        },
        {
            type: GdShowConditionAutobudgetPriority.HIGH,
            text: mapAutobudgetPriorityToString(GdShowConditionAutobudgetPriority.HIGH)
        }
    ];

    render() {
        const { isLoading, note, autobudgetPriority, onCancel, onSave } = this.props;

        return (
            <div className={Bem.cls(BLOCK)}>
                {note && <div className={Bem.cls(BLOCK, 'note')}>{note}</div>}
                <div className={Bem.cls(BLOCK, 'controls')}>
                    <span className={Bem.cls(BLOCK, 'autobudget-label')}>{i18n('autobudget-label')}</span>
                    <RadioButton
                        freeWidth={true}
                        theme="normal"
                        view="default"
                        value={autobudgetPriority}
                        size="n"
                        onChange={this.onAutobudgetPriorityChange}
                    >
                        {this.autobudgetPriorities.map(({ type, text }) => (
                            <RadioButton.Radio key={type} value={type}>
                                {text}
                            </RadioButton.Radio>
                        ))}
                    </RadioButton>
                </div>
                <ButtonDecorator
                    progress={isLoading}
                    cls={Bem.cls(BLOCK, 'apply-button')}
                    theme="action"
                    view="default"
                    size="n"
                    tone="default"
                    text={i18n('update')}
                    onClick={onSave}
                />
                <ButtonDecorator
                    tone="default"
                    view="default"
                    size="n"
                    theme="normal"
                    text={i18n('cancel')}
                    onClick={onCancel}
                />
            </div>
        );
    }

    private onAutobudgetPriorityChange = (event: ChangeEvent<HTMLInputElement>) => {
        this.props.onAutobudgetPriorityChange(event.target.value as GdShowConditionAutobudgetPriority);
    };
}
